import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MongoService } from 'src/app/services/mongo.service';
import { NavigatorService } from 'src/app/services/navigator.service';
import { StateService } from 'src/app/services/state.service';

@Component({
  selector: 'users-management-view',
  templateUrl: './users-management-view.component.html',
  styleUrl: './users-management-view.component.css'
})
export class UsersManagementViewComponent implements OnInit {

  data: any;
  displayedItems: Array<any> = [];
  currentFilterValue: string = "";
  isSpinnerVisible:boolean = false;

  constructor(
    public mongoService: MongoService,
    private changeDetector: ChangeDetectorRef,
    private navigatorService: NavigatorService,
    private navigator: NavigatorService,
    private stateService: StateService
  ){}

  async ngOnInit(): Promise<void> {
    this.isSpinnerVisible = true;
    this.data = await this.mongoService.getAllUsersData() ?? [];
    this.filterUsersByActiveCampaignDevices();
    await this.markUsersWithPlacedOrders();
    if(this.stateService.getState() == 'state-pumps'){
      this.data.sort((a:any, b:any) => {
        if (a.pumpPosition === 0 && b.pumpPosition === 0) return 0;
        if (a.pumpPosition === 0) return 1;
        if (b.pumpPosition === 0) return -1;
        return a.pumpPosition - b.pumpPosition;
      });
    }
    else if(this.stateService.getState() == 'state-airconditioners'){
      this.data.sort((a:any, b:any) => {
        if (a.airConditionPosition === 0 && b.airConditionPosition === 0) return 0;
        if (a.airConditionPosition === 0) return 1;
        if (b.airConditionPosition === 0) return -1;
        return a.airConditionPosition - b.airConditionPosition;
      });
    }
    this.isSpinnerVisible = false;
  }

  // Pokazuje wyłącznie użytkowników z zarejestrowanym urządzeniem w aktywnej
  // kampanii. *RegisteredProducts to tablice w dokumencie usersData, więc filtr
  // działa w całości na danych już pobranych, bez dodatkowych zapytań.
  private filterUsersByActiveCampaignDevices(): void {
    const state = this.stateService.getState();
    if (state === 'state-pumps') {
      this.data = this.data.filter((user: any) => (user?.pumpRegisteredProducts?.length ?? 0) > 0);
    } else if (state === 'state-airconditioners') {
      this.data = this.data.filter((user: any) => (user?.airConditionRegisteredProducts?.length ?? 0) > 0);
    }
  }

  // Oznacza userów, którzy mają złożone zamówienie w bieżącej kampanii.
  // Zamówienia żyją w osobnych kolekcjach per kampania i są skojarzone po
  // userEmail — usersData nie trzyma flagi zamówienia. Email normalizujemy po obu
  // stronach (lowercase + trim), bo zamówienie zapisuje surowy email z Firebase,
  // a usersData trzyma go małymi literami.
  private async markUsersWithPlacedOrders(): Promise<void> {
    const state = this.stateService.getState();
    let orders: Array<any> = [];
    if (state === 'state-pumps') {
      orders = await this.mongoService.getPumpsUsersOrders();
    } else if (state === 'state-airconditioners') {
      orders = await this.mongoService.getAirconditionersUsersOrders();
    }
    const orderedEmails = new Set<string>(
      (orders ?? [])
        .map((order: any) => String(order?.userEmail ?? '').toLowerCase().trim())
        .filter((email: string) => email.length > 0)
    );
    for (const user of (this.data ?? [])) {
      user.hasPlacedOrder = orderedEmails.has(String(user?.userEmail ?? '').toLowerCase().trim());
    }
  }

  filterValueChanged(event: any): void{
    this.currentFilterValue = event?.target?.value.toLowerCase();
  }

  updateDisplayedList(items: Array<any>): void{
    this.displayedItems = items;
    this.changeDetector.detectChanges();
  }

  openItem(selectedUser : any){
    this.navigatorService.redirectToUserEditScreen(selectedUser.userEmail);
  }

  public redirectToAdministrationScreen() : void {
    this.navigator.redirectToAdministrationScreen();
  }
}
